module.exports = __webpack_public_path__ + "media/images/icons/unit-cca89249563e186d29a3c7ac9cd88bc7.svg";